module.exports = __webpack_public_path__ + "static/media/recharge.d10e8ee7.jpg";